import { Base } from "@/components/Product/ECommerce/components/delivery/components/deliveryTypes/deliveryItem/components/clickAndCollect/clickAndCollect.base";
import { BoxPromise } from "@/components/Product/ECommerce/components/delivery/components/deliveryTypes/deliveryItem/components/clickAndCollect/components/boxPromise";
import { ItemStock } from "@/components/Product/ECommerce/components/delivery/components/deliveryTypes/deliveryItem/components/clickAndCollect/components/itemstock";
import { LimitedStock } from "@/components/Product/ECommerce/components/delivery/components/deliveryTypes/deliveryItem/components/clickAndCollect/components/limitedStock";
import { NoStore } from "@/components/Product/ECommerce/components/delivery/components/deliveryTypes/deliveryItem/components/clickAndCollect/components/noStore";
import { StorePickerButton } from "@/components/Product/ECommerce/components/delivery/components/deliveryTypes/deliveryItem/components/clickAndCollect/components/storePickerButton";

export const ClickAndCollect = Object.assign(Base, {
    BoxPromise: BoxPromise,
    ItemStock: ItemStock,
    LimitedStock: LimitedStock,
    NoStore: NoStore,
    StorePickerButton: StorePickerButton
});
